import type { StaticImageData } from 'next/image';
import avatarNoImg from '@/../public/img/avatarNoImg.jpg';
import imgImoon from '@/../public/img/gameProviders/imoon.png';
import * as pngOriginalProviderIcons from '@/../public/img/gameProviders/originalProviders';
import imgEvolution from '@/../public/img/gameProviders/originalProviders/Evolution.png';
import imgPlayNGo from '@/../public/img/gameProviders/originalProviders/PlaynGo.png';
import imgPragmaticPlay from '@/../public/img/gameProviders/originalProviders/pragmaticPlay.png';
import imgPragmaticPlayLive from '@/../public/img/gameProviders/originalProviders/pragmaticPlayLive.png';
import imgSoftGaming from '@/../public/img/gameProviders/softgaming.png';
import imgTurboStars from '@/../public/img/gameProviders/turbostars.png';
import centralPayImg from '@/../public/img/gatewayOptions/central-pay.svg';
import cpgImg from '@/../public/img/gatewayOptions/cpg.svg';
import jbImg from '@/../public/img/gatewayOptions/jb.svg';
import metamaskImg from '@/../public/img/gatewayOptions/metamask.svg';
import minipayImg from '@/../public/img/gatewayOptions/minipay.svg';
import perfectmoneyImg from '@/../public/img/gatewayOptions/perfect-money.svg';
import tomanImg from '@/../public/img/gatewayOptions/toman.svg';
import web3Img from '@/../public/img/gatewayOptions/web-3.svg';
import witcherImg from '@/../public/img/gatewayOptions/witcher.svg';
import ziChargeImg from '@/../public/img/gatewayOptions/zi-charge.svg';
import iconMetamask from '@/../public/img/metamask.png';
import * as svgIcons from '@/../public/svg/currency';
import { BadgeTotalCount } from '@/store/reducers/badges-slice';
import {
  AdminRoles,
  GameProviders,
  PaymentCategory,
  PaymentProviderName,
  ReportTimeInterval,
} from '@alien-platform/bo-core';
import { PlayerProfileType } from '@alien-platform/bo-core/lib/players/types/enum/player.profile.enum';
import { faGoogle, faTelegram } from '@fortawesome/free-brands-svg-icons';
import {
  faChartLine,
  faCircleUser,
  faCloudCheck,
  faCoin,
  faCoins,
  faCreditCard,
  faDice,
  faEnvelope,
  faFileInvoiceDollar,
  faFileUser,
  faGears,
  faHandHoldingDollar,
  faHandsHoldingDollar,
  faHouseChimney,
  faHouseCircleExclamation,
  faIdCard,
  faLifeRing,
  faMoneyBill1,
  faMoneyBillTransfer,
  faMoneyFromBracket,
  faMoneySimpleFromBracket,
  faNewspaper,
  faRightLeft,
  faRobot,
  faRotateReverse,
  faScrewdriverWrench,
  faStars,
  faUsers,
  faUsersBetweenLines,
  faUsersViewfinder,
  faUserTie,
  faVault,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import type { ManipulateType } from 'dayjs';

import {
  AllFilters,
  BannerProps,
  CountryMapping,
  GameCategory,
  GameTag,
  MediaItemProps,
  PermissionsSections,
  PlayerSubInfo,
} from '@/types/general';
import { california } from '@/styles/theme/colors';

export const svgIconsTyped = svgIcons;
export const originalProviderIcons = pngOriginalProviderIcons;

export const currentVersion = '1.0.127';

export const drawerWidth = 250;

export interface MenuDrawerItem {
  open?: boolean;
  label: string;
  path?: string;
  subMenu?: MenuDrawerItem[];
  icon?: IconDefinition;
  requiredRoles?: AdminRoles[];
  count?: number;
  flag?: BadgeTotalCount;
  permissionKey?: string;
  excludeForBrand?: boolean;
}

export interface DataCardType {
  title: string;
  description?: string;
  key?: string;
  value?: number;
  secondaryValue?: number;
  difference?: number;
  percentage?: number;
  icon: IconDefinition;
  iconColor?: string;
  iconBgColor?: string;
  currency?: string;
  requiredRoles?: AdminRoles[];
  strikethrough?: boolean;
}

export const initialTableFilters: AllFilters = {
  playerId: '',
  playerCode: '',
  provider: undefined,
  status: undefined,
  betStatus: undefined,
  type: undefined,
  betId: '',
  nickName: '',
  telegramId: '',
  category: '',
  email: '',
  gameProvider: undefined,
  gameId: '',
  gameTitle: '',
  betAmount: undefined,
  winOdds: undefined,
  currency: undefined,
  isTest: undefined,
  isDeleted: undefined,
  fromDate: '',
  toDate: '',
  registrationTimeFrom: '',
  registrationTimeTo: '',
  activityTimeFrom: '',
  activityTimeTo: '',
  isSettled: false,
  affId: undefined,
  refId: undefined,
  channelId: '',
  networkName: '',
  hasImageUrl: undefined,
  txId: '',
  includeTags: undefined,
  excludeTags: undefined,
  registrationMethod: undefined,
  hasPlayed: undefined,
  hasDeposit: undefined,
  hasWithdraw: undefined,
  hasTopup: undefined,
  hasPendingVerification: undefined,
  isBlocked: undefined,
  chatIsBlocked: undefined,
  cardNumber: undefined,
  playerUid: undefined,
  minBetAmount: undefined,
  maxBetAmount: undefined,
  maxWinOdds: undefined,
  minWinOdds: undefined,
  subType: undefined,
  rtp: undefined,
  hasRefId: undefined,
  hasAffId: undefined,
  userCode: undefined,
  user_id: undefined,
  telegramUsername: undefined,
  actionMenu: undefined,
  isBonusEligible: undefined,
  areas: undefined,
  roles: undefined,
  bonusType: undefined,
  prizeType: undefined,
  bonusStatus: undefined,
  bonusSubType: undefined,
  bonusDefinitionType: undefined,
  bonusId: undefined,
  isBrand: undefined,
  bonusBetType: undefined,
  isFTD: undefined,
  isActive: undefined,
  ticketNumber: undefined,
  appName: undefined,
  appState: undefined,
  appEnv: undefined,
  timePeriod: undefined,
  filterBy: undefined,
  filterValue: undefined,
};

export const permissionsCategories = [
  {
    title: 'All Permissions',
    value: PermissionsSections.ALL,
  },
  {
    title: 'Players',
    value: PermissionsSections.PLAYERS,
  },
  {
    title: 'Bets',
    value: PermissionsSections.BETS,
  },
  {
    title: 'Deposit',
    value: PermissionsSections.DEPOSIT,
  },
  {
    title: 'Withdraw',
    value: PermissionsSections.WITHDRAW,
  },
  {
    title: 'Operators',
    value: PermissionsSections.OPERATORS,
  },
  {
    title: 'Bonus',
    value: PermissionsSections.BONUS,
  },
  {
    title: 'Tournament',
    value: PermissionsSections.TOURNAMENT,
  },
  {
    title: 'Staff Settings',
    value: PermissionsSections.STAFF_SETTINGS,
  },
];

export const dashboardCards: DataCardType[] = [
  {
    title: 'Today Registrations',
    key: 'registrations',
    value: 0,
    secondaryValue: 0,
    difference: 0, // Updated difference value
    percentage: 0, // Updated percentage value
    icon: faHandHoldingDollar,
    iconColor: california[300],
    iconBgColor: california[300],
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  },

  {
    title: 'Today FTD',
    description: 'First Time Deposit',
    key: 'ftd',
    value: 0,
    icon: faMoneyFromBracket,
    iconColor: california[300],
    iconBgColor: california[300],
    difference: 0, // Updated difference value
    percentage: 0, // Updated percentage value
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  },
  {
    title: 'Today Unique Active Players',
    key: 'activePlayers',
    value: 0,
    difference: 0, // Updated difference value
    percentage: 0, // Updated percentage value
    icon: faUsers,
    iconColor: california[300],
    iconBgColor: california[300],
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  },
  {
    title: 'Today Bets',
    key: 'bets',
    value: 0,
    icon: faCoin,
    difference: 0, // Updated difference value
    percentage: 0, // Updated percentage value
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
    iconColor: california[300],
    iconBgColor: california[300],
  },
  {
    title: 'Today PL in USD',
    description: 'Profit/Loss in USD',
    key: 'pl',
    value: 0,
    icon: faHandsHoldingDollar,
    difference: 0, // Updated difference value
    percentage: 0, // Updated percentage value
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
    iconColor: california[300],
    iconBgColor: california[300],
  },
  // {
  //   title: 'Today Commissions',
  //   key: '',
  //   value: 786,
  //   currency: 'USD',
  //   difference: 800, // Updated difference value
  //   percentage: 32, // Updated percentage value
  //   icon: faHandHoldingDollar,
  //   iconColor: themeColors.persian_green[5],
  //   iconBgColor: themeColors.persian_green[12],
  //   requiredRoles: [AdminRoles.SUPER_ADMIN],
  // },
  {
    title: 'Today FTDs',
    key: 'ftd',
    value: 0,
    secondaryValue: 0,
    difference: 0,
    percentage: 0,
    icon: faMoneySimpleFromBracket,
    requiredRoles: [AdminRoles.ADMIN],
    description: 'First time deposit count today',
  },
  {
    title: 'Today Net Deposit',
    key: '',
    value: 0,
    currency: 'USD',
    secondaryValue: 0,
    difference: 0,
    percentage: 0,
    icon: faMoneyBillTransfer,
    requiredRoles: [AdminRoles.ADMIN],
  },
  {
    title: 'Today Turnover',
    key: '',
    value: 0,
    secondaryValue: 0,
    difference: 0,
    percentage: 0,
    icon: faRotateReverse,
    requiredRoles: [AdminRoles.ADMIN],
  },
  {
    title: 'Today GGR',
    key: '',
    value: 0,
    secondaryValue: 0,
    difference: 0,
    percentage: 0,
    icon: faVault,
    requiredRoles: [AdminRoles.ADMIN],
    description: 'Gross gaming revenue today',
  },
];

export const menuDrawer: MenuDrawerItem[] = [
  {
    label: 'Dashboard',
    path: 'dashboard',
    open: false,
    permissionKey: 'dashboard',
    icon: faHouseChimney,
    // requiredRoles: [
    //   AdminRoles.SUPER_ADMIN,
    //   AdminRoles.ADMIN,
    //   AdminRoles.OPERATOR_ADMIN,
    // ],
  },
  // {
  //   label: 'Dashboard V2',
  //   path: 'dashboardV2',
  //   open: false,
  //   permissionKey: 'dashboard_v2',
  //   icon: faHouseCircleExclamation,
  //   // requiredRoles: [
  //   //   AdminRoles.SUPER_ADMIN,
  //   //   AdminRoles.ADMIN,
  //   //   AdminRoles.OPERATOR_ADMIN,
  //   // ],
  // },
  {
    label: 'Quick Dashboard',
    path: 'quick-dashboard',
    open: false,
    permissionKey: 'quick_dashboard',
    icon: faHouseCircleExclamation,
    // requiredRoles: [
    //   AdminRoles.SUPER_ADMIN,
    //   AdminRoles.ADMIN,
    //   AdminRoles.OPERATOR_ADMIN,
    // ],
  },
  {
    label: 'Reports',
    path: 'reports',
    open: false,
    permissionKey: 'reports',
    icon: faChartLine,
    subMenu: [
      {
        label: 'Operators Report',
        path: 'reports/operator',
        permissionKey: 'reports_operators',
      },
      {
        label: 'Games Report',
        path: 'reports/games',
        permissionKey: 'reports_games',
      },
      // {
      //   label: 'Game Providers Report',
      //   path: 'reports/game-providers',
      //   permissionKey: 'reports_games',
      // },
      {
        label: 'Game Operator Report',
        path: `reports/game-operator`,
        // path: `reports/game-operator?month=${dayjs().format('MMMM').toUpperCase()}`,
        permissionKey: 'reports_games_per_operator',
      },
      {
        label: 'Operator Report',
        path: `reports/operator`,
        // path: `reports/game-operator?month=${dayjs().format('MMMM').toUpperCase()}`,
        permissionKey: 'reports_games_per_operator',
      },
      {
        label: 'Transactions Report',
        path: 'reports/transactions',
        permissionKey: 'reports_transactions',
      },
      // {
      //   label: 'Affiliates Report',
      //   path: 'reports/affiliates',
      //   permissionKey: 'reports_affiliates',
      // },
      {
        label: 'Bonus Transactions Report',
        path: 'reports/bonus-transactions',
        permissionKey: 'reports_bonus_transactions',
      },
      {
        label: 'Bonus Releases Report',
        path: 'reports/bonus-releases',
        permissionKey: 'reports_bonus_releases',
      },
      {
        label: 'Transaction Operator Report',
        path: 'reports/transaction-operator',
        permissionKey: 'reports_transactions_per_operator',
      },
      {
        label: 'Top Affiliates Report',
        path: 'reports/top-affiliates',
        permissionKey: 'reports_top_affiliates',
      },
      {
        label: 'Top Channels Report',
        path: 'reports/top-channels',
        permissionKey: 'reports_top_channels',
      },
      {
        label: 'Risk Management Report',
        path: 'reports/risk-management',
        permissionKey: 'reports_risk_management',
      },
      // { label: 'Pending Verification', path: 'players/pending', flag: 'kyc' },
    ],
    // requiredRoles: [
    //   AdminRoles.SUPER_ADMIN,
    //   AdminRoles.ADMIN,
    //   AdminRoles.OPERATOR_ADMIN,
    // ],
  },
  // {
  //   label: 'Channels',
  //   path: 'channels',
  //   open: false,
  //   icon: faUserFriends,
  //   requiredRoles: [AdminRoles.ADMIN],
  //   permissionKey: 'channels',
  // },
  // {
  //   label: 'Profit History',
  //   path: 'profit-history',
  //   open: false,
  //   permissionKey: 'channels',
  //   icon: faFileInvoiceDollar,
  //   requiredRoles: [AdminRoles.ADMIN],
  // },
  {
    label: 'Operators',
    // path: 'operators',
    open: false,
    icon: faUsersViewfinder,
    requiredRoles: [AdminRoles.SUPER_ADMIN],
    permissionKey: 'operators',
    subMenu: [
      {
        label: 'All Operators',
        path: 'operators',
        flag: BadgeTotalCount.DOCUMENT,
        permissionKey: 'operators',
      },
      {
        label: 'Parent Operators',
        path: 'operators?type=parent',
        permissionKey: 'operators',
      },
      {
        label: 'Brand Operators',
        path: 'operators?type=brand',
        permissionKey: 'operators',
      },
    ],
    // subMenu: [
    //   { label: 'Operators', permissionKey: 'operators', path: 'operators' },
    //   {
    //     label: 'Operators Activities',
    //     permissionKey: 'sub_operators_activities',
    //     path: 'operators/activities',
    //     requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
    //   },
    // ],
  },
  {
    label: 'Brands',
    path: 'brands',
    open: false,
    icon: faUsersBetweenLines,
    requiredRoles: [AdminRoles.OPERATOR_ADMIN],
    permissionKey: 'brands',
    excludeForBrand: true,
  },
  {
    label: 'Players',
    permissionKey: 'players',
    flag: BadgeTotalCount.USERNAME,
    subMenu: [
      { label: 'Players List', path: 'players', permissionKey: 'sub_players' },
      // {
      //   label: 'Players Activities',
      //   path: 'players/activities',
      //   permissionKey: 'sub_players_activities',
      // },
      // {
      //   label: 'Players Details Activities',
      //   path: 'players/details-activities',
      //   permissionKey: 'sub_players_details_activities',
      // },
      {
        label: 'Players Balances',
        path: 'players/balances',
        permissionKey: 'sub_players_balances',
      },
      {
        label: 'Players Usernames',
        path: 'players/usernames',
        permissionKey: 'sub_players_usernames',
        flag: BadgeTotalCount.USERNAME,
      },

      // { label: 'Pending Verification', path: 'players/pending', flag: 'kyc' },
    ],
    open: false,
    icon: faUsers,
    // flag: 'kyc',
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  {
    label: 'Bonus',
    permissionKey: 'bonus',
    subMenu: [
      {
        label: 'Bonus Definitions',
        path: 'bonus',
        permissionKey: 'sub_bonus_list',
      },
      {
        label: 'Bonus Releases',
        path: 'bonus/releases',
        permissionKey: 'sub_bonus_unlocking',
      },
      {
        label: 'Sport FreeBets',
        path: 'bonus/sport',
        permissionKey: 'sub_bonus_sport_freebet_list',
      },
      {
        label: 'Bonus Transactions',
        path: 'bonus/transactions',
        permissionKey: 'sub_bonus_transactions',
      },
      {
        label: 'Bonus Claims',
        path: 'bonus/claims',
        permissionKey: 'sub_bonus_claims',
      },
      // {
      //   label: 'Cashback Bonus',
      //   path: 'bonus/cashback',
      //   permissionKey: 'sub_bonus_cashback',
      // },
    ],
    open: false,
    icon: faStars,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },

  {
    label: 'Deposit',
    permissionKey: 'deposit',
    flag: BadgeTotalCount.DEPOSIT,
    subMenu: [
      // { label: 'All', path: 'transactions' },
      {
        label: 'Deposit List',
        path: 'deposit/list',
        permissionKey: 'sub_deposit_list',
      },
      {
        label: 'Deposit Pending',
        path: 'deposit/pending',
        permissionKey: 'sub_transactions_deposit',
        flag: BadgeTotalCount.DEPOSIT,
      },
      {
        label: 'Deposit Orders',
        path: 'deposit/orders',
        permissionKey: 'sub_transactions_deposit_orders',
      },
      // {
      //   label: 'Deposit Gateways',
      //   path: 'deposit/gateways',
      //   permissionKey: 'sub_transactions_deposit_gateways',
      // },
      {
        label: 'Deposit Gateways',
        path: 'deposit/gatewaysV2',
        permissionKey: 'sub_transactions_deposit_gateways_v2',
      },
      {
        label: 'Topup List',
        path: 'topup/list',
        permissionKey: 'sub_transactions_topup',
      },
    ],
    open: false,
    icon: faCreditCard,
    // count: 4,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  {
    label: 'Withdraw',
    flag: BadgeTotalCount.WITHDRAW,
    permissionKey: 'withdraw',
    subMenu: [
      // { label: 'All', path: 'transactions' },
      {
        label: 'Withdraw List',
        path: 'withdraw/list',
        permissionKey: 'sub_withdraw_list',
      },
      {
        label: 'Withdraw Pending',
        path: 'withdraw/pending',
        flag: BadgeTotalCount.WITHDRAW,
        permissionKey: 'sub_withdraw_pending',
      },
      // {
      //   label: 'Withdraw Gateways',
      //   path: 'withdraw/gateways',
      //   permissionKey: 'sub_withdraw_gateways',
      // },
      {
        label: 'Withdraw Gateways',
        path: 'withdraw/gatewaysV2',
        permissionKey: 'sub_withdraw_gateways_v2',
      },
      {
        label: 'Withdraw Treasuries',
        path: 'withdraw/treasuries',
        permissionKey: 'sub_withdraw_treasuries',
      },
      {
        label: 'Bank Accounts',
        path: 'withdraw/bank-accounts',
        permissionKey: 'sub_bank_accounts',
      },
    ],
    open: false,
    icon: faMoneyBill1,
    // count: 4,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  {
    label: 'Transactions',
    permissionKey: 'transactions',
    subMenu: [
      // { label: 'All', path: 'transactions' },
      {
        label: 'Transactions List',
        path: 'transactions/list',
        permissionKey: 'sub_transactions_list',
      },
      // {
      //   label: 'Transactions Activities',
      //   path: 'transactions/transactions-activities',
      //   permissionKey: 'sub_transactions_activities',
      // },
    ],
    open: false,
    icon: faMoneyBillTransfer,
    // count: 4,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
  },
  {
    label: 'Support',
    path: 'support',
    open: false,
    flag: BadgeTotalCount.SUPPORT,
    icon: faLifeRing,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
    permissionKey: 'support',
    // subMenu: [
    //   { label: 'Support', path: 'support', permissionKey: 'support' },
    //   {
    //     label: 'Support Activities',
    //     path: 'support/activities',
    //     permissionKey: 'sub_support_activity',
    //     requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
    //   },
    // ],
  },
  {
    label: 'Documents',
    permissionKey: 'documents',
    subMenu: [
      {
        label: 'Documents Pending',
        path: 'documents?status=PENDING',
        flag: BadgeTotalCount.DOCUMENT,
        permissionKey: 'sub_documents_pending',
      },
      {
        label: 'Documents Confirmed',
        path: 'documents?status=CONFIRMED',
        permissionKey: 'sub_documents_confirmed',
      },
      {
        label: 'Documents Rejected',
        path: 'documents?status=REJECTED',
        permissionKey: 'sub_documents_rejected',
      },
      {
        label: 'Documents List ',
        path: 'documents',
        permissionKey: 'sub_documents_all',
      },
    ],
    open: false,
    icon: faFileUser,
    flag: BadgeTotalCount.DOCUMENT,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },

  {
    label: 'Bets',
    permissionKey: 'bets',
    subMenu: [{ label: 'Bets List', path: 'bets', permissionKey: 'sub_bets' }],
    open: false,
    icon: faCoins,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },

  // {
  //   label: 'Payment',
  //   permissionKey: 'payment',
  //   subMenu: [
  //     {
  //       label: 'Payment Categories',
  //       path: 'payment/categories',
  //       requiredRoles: [AdminRoles.SUPER_ADMIN],
  //       permissionKey: 'sub_payment_categories',
  //     },
  //     {
  //       label: 'Reports',
  //       path: 'payment/reports',
  //       permissionKey: 'sub_payment_reports',
  //     },
  //   ],
  //   open: false,
  //   icon: faFileInvoiceDollar,
  //   requiredRoles: [
  //     AdminRoles.SUPER_ADMIN,
  //     AdminRoles.OPERATOR_ADMIN,
  //     AdminRoles.OPERATOR_MANAGER,
  //   ],
  // },

  {
    label: 'Treasury Account',
    path: 'treasury-account',
    permissionKey: 'treasury_account',
    open: false,
    icon: faVault,
    requiredRoles: [AdminRoles.SUPER_ADMIN],
  },

  {
    label: 'Games',
    permissionKey: 'games',
    subMenu: [
      { label: 'Games List', path: 'games', permissionKey: 'sub_games_list' },
      // {
      //   label: 'Providers List',
      //   path: 'games/providers',
      //   permissionKey: 'sub_games_providers',
      // },
    ],
    open: false,
    icon: faDice,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },

  {
    label: 'Exchange Rates',
    path: 'exchange-rates',
    permissionKey: 'exchange_rates',
    open: false,
    icon: faRightLeft,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  {
    label: 'Tech Support',
    permissionKey: 'tech_support',
    subMenu: [
      {
        label: 'Export Report',
        path: 'coming-soon',
        permissionKey: 'sub_tech_support_export_report',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      {
        label: 'Servers',
        path: 'tech-support/servers',
        permissionKey: 'sub_tech_support_servers',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
    ],
    open: false,
    icon: faScrewdriverWrench,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
  },
  {
    label: 'Billing',
    permissionKey: 'billing',
    subMenu: [
      {
        label: 'My Billing',
        path: 'billing/me',
        permissionKey: 'billing_me',
        // permissionKey: 'sub_billing_me',
        requiredRoles: [AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
      },
      {
        label: 'Operators Billing',
        path: 'billing/operators',
        permissionKey: 'sub_billing_operators',
        requiredRoles: [
          AdminRoles.SUPER_ADMIN,
          AdminRoles.ADMIN,
          AdminRoles.OPERATOR_ADMIN,
          AdminRoles.OPERATOR_MANAGER,
        ],
      },
      {
        label: 'Operators Billing V2 (Preview)',
        path: 'billing/operatorsV2',
        permissionKey: 'sub_billing_operators',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      {
        label: 'Brands Billing',
        path: 'billing/brands',
        permissionKey: 'sub_billing_brands',
        requiredRoles: [AdminRoles.SUPER_ADMIN],
        excludeForBrand: true,
      },

      // {
      //   label: 'Affiliates Billing',
      //   path: 'billing/affiliates',
      //   permissionKey: 'sub_billing_affiliates',
      //   requiredRoles: [
      //     AdminRoles.SUPER_ADMIN,
      //     AdminRoles.ADMIN,
      //     AdminRoles.OPERATOR_ADMIN,
      //   ],
      // },
    ],
    open: false,
    icon: faFileInvoiceDollar,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
  },
  {
    label: 'Settings',
    permissionKey: 'settings',
    subMenu: [
      {
        label: 'General',
        path: 'settings/general',
        permissionKey: 'sub_settings_operator_general_settings',
        requiredRoles: [AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
      },
      {
        label: 'Tiers',
        path: 'settings/tiers',
        permissionKey: 'sub_settings_operator_tiers',
        requiredRoles: [AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
      },
      // {
      //   label: 'Tags',
      //   path: 'settings/tags',
      //   requiredRoles: [AdminRoles.SUPER_ADMIN],
      //   permissionKey: 'sub_settings_tags',
      // },
      {
        label: 'Translation',
        path: 'settings/translation',
        requiredRoles: [AdminRoles.SUPER_ADMIN],
        permissionKey: 'sub_settings_translation',
      },
      {
        label: 'Staff List',
        path: 'settings/admins',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
        permissionKey: 'sub_settings_users',
      },
      {
        label: 'Staff Activity',
        path: 'settings/activities',
        permissionKey: 'sub_settings_users_activities',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      // {
      //   label: 'Login Activity',
      //   path: 'settings/login-activitiy',
      //   permissionKey: 'sub_settings_login_activities',
      //   requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      // },
      // {
      //   label: 'Staff Activity',
      //   path: 'settings/user-activity',
      //   permissionKey: 'sub_settings_users_activities',
      //   requiredRoles: [AdminRoles.SUPER_ADMIN],
      // },
      {
        label: 'Notifications',
        path: 'settings/notifications',
        requiredRoles: [AdminRoles.SUPER_ADMIN],
        permissionKey: 'sub_settings_notifications',
      },
      {
        label: 'Cloudflare Account',
        path: 'settings/cf-account',
        requiredRoles: [AdminRoles.SUPER_ADMIN],
        permissionKey: 'sub_settings_cloudflare_account',
      },
      {
        label: 'Domains',
        path: 'settings/domains',
        requiredRoles: [
          AdminRoles.SUPER_ADMIN,
          AdminRoles.OPERATOR_ADMIN,
          AdminRoles.OPERATOR_MANAGER,
          AdminRoles.DEV_OPS,
        ],
        permissionKey: 'sub_settings_domains',
      },
      {
        label: 'Roles & Permissions',
        path: 'settings/roles',
        requiredRoles: [AdminRoles.SUPER_ADMIN],
        permissionKey: 'sub_settings_roles',
      },
    ],
    open: false,
    icon: faGears,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  {
    label: 'CMS',
    permissionKey: 'cms',
    subMenu: [
      {
        label: 'Branding',
        path: 'cms/branding',
        permissionKey: 'sub_cms_branding',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      {
        label: 'Sliders',
        path: 'cms/homepage/sliders',
        permissionKey: 'sub_cms_sliders',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      {
        label: 'Homepage',
        path: 'cms/template',
        permissionKey: 'sub_cms_template',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },

      {
        label: 'Pages',
        path: 'cms/pages',
        permissionKey: 'sub_cms_page',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      {
        label: 'Modals',
        path: 'cms/modals',
        permissionKey: 'sub_cms_modals',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },

      {
        label: 'File Manager',
        path: 'cms/file-manager',
        permissionKey: 'sub_cms_gallery',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },

      {
        label: 'Footer',
        path: 'cms/footer',
        permissionKey: 'sub_cms_footer',
        requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      },
      {
        label: 'Operators',
        path: 'cms/operators',
        permissionKey: 'sub_cms_operators',
        requiredRoles: [AdminRoles.SUPER_ADMIN],
      },
      // {
      //   label: 'Activities',
      //   path: 'cms/activities',
      //   permissionKey: 'sub_cms_activities',
      //   requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
      // },
    ],
    open: false,
    icon: faUserTie,
    requiredRoles: [AdminRoles.SUPER_ADMIN],
  },
  // {
  //   label: 'Affiliates',
  //   path: 'affiliates',
  //   permissionKey: 'affiliates',
  //   open: false,
  //   icon: faBriefcase,
  //   requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  // },
  {
    label: 'DEVOPS',
    path: 'settings/dev',
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.DEV_OPS, AdminRoles.ADMIN],
    permissionKey: 'sub_settings_dev',
    open: false,
    icon: faCloudCheck,
  },

  // {
  //   label: 'Users',
  //   path: 'settings/users',
  //   open: false,
  //   icon: faUsers,
  //   requiredRoles: [AdminRoles.OPERATOR_ADMIN],
  // },

  {
    label: 'Flows',
    path: 'flows',
    permissionKey: 'flows',
    open: false,
    icon: faRobot,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  // {
  //   label: "What's New",
  //   path: 'latest-updates',
  //   permissionKey: 'latest_updates',
  //   open: false,
  //   icon: faNewspaper,
  //   requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  // },
  {
    label: "What's New",
    path: 'whats-new',
    permissionKey: 'latest_updates',
    open: false,
    icon: faNewspaper,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN, AdminRoles.OPERATOR_MANAGER],
  },
  {
    label: "What's New (SA)",
    path: 'whats-new/super-admin',
    permissionKey: 'latest_updates_super_admin',
    open: false,
    icon: faNewspaper,
    requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.ADMIN],
  },

  // {
  //   label: 'CMS',
  //   path: 'cms',
  //   open: false,
  //   icon: faPenPaintbrush,
  //   requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  //   subMenu: [
  //     {
  //       label: 'Pages',
  //       path: 'cms/pages',
  //       icon: faFilePen,
  //       requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  //     },
  //     {
  //       label: 'Footer',
  //       path: 'cms/footer',
  //       icon: faFilePen,
  //       requiredRoles: [AdminRoles.SUPER_ADMIN, AdminRoles.OPERATOR_ADMIN],
  //     },
  //   ],
  // },
];

export const NetworkBlockExplorers = [
  {
    network: 'ETHEREUM_MAIN',
    blockchainExplorerUrl: 'https://etherscan.io/',
  },
  {
    network: 'POLYGON_MAIN',
    blockchainExplorerUrl: 'https://polygonscan.com',
  },
  {
    network: 'POLYGON_TEST',
    blockchainExplorerUrl: 'https://mumbai.polygonscan.com/tx',
  },
  {
    network: 'CELO_MAIN',
    blockchainExplorerUrl: 'https://explorer.celo.org/mainnet',
  },
  {
    network: 'CELO_TEST',
    blockchainExplorerUrl: 'https://alfajores.celoscan.io/',
  },
];

export const PaymentCategoriesDetails: Record<
  PaymentCategory,
  { logo: StaticImageData; title: string; subtitle?: string }
> = {
  [PaymentCategory.PERFECT_MONEY]: {
    logo: perfectmoneyImg as StaticImageData,
    title: 'Perfect Money',
    subtitle: 'Fiat',
  },
  [PaymentCategory.MINI_PAY]: {
    logo: minipayImg as StaticImageData,
    title: 'MiniPay',
    subtitle: 'Connect Your Wallet',
  },
  [PaymentCategory.WEB3]: {
    logo: metamaskImg as StaticImageData,
    title: 'Web 3.0',
    subtitle: 'Connect Your Wallet',
  },
  [PaymentCategory.TOMANI]: {
    logo: tomanImg as StaticImageData,
    title: 'Tomani',
    subtitle: 'Fiat',
  },
  [PaymentCategory.CRYPTO]: {
    logo: cpgImg as StaticImageData,
    title: 'Crypto',
    subtitle: 'Coming Soon...',
  },
};

export const PaymentProviderDetails: Record<
  PaymentProviderName,
  { logo: StaticImageData; title: string; subtitle?: string }
> = {
  [PaymentProviderName.PERFECT_MONEY]: {
    logo: perfectmoneyImg,
    title: 'Perfect Money',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.MINI_PAY]: {
    logo: minipayImg,
    title: 'MiniPay',
    subtitle: 'Connect Your Wallet',
  },
  [PaymentProviderName.WEB3]: {
    logo: web3Img,
    title: 'Web 3.0',
    subtitle: 'Connect Your Wallet',
  },
  [PaymentProviderName.JB]: {
    logo: jbImg,
    title: 'JB',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.CENTRAL_PAY]: {
    logo: centralPayImg,
    title: 'Central Pay',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.WITCHER]: {
    logo: witcherImg,
    title: 'Witcher',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.TOMANI]: {
    logo: tomanImg,
    title: 'Tomani',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.CPG]: {
    logo: cpgImg,
    title: 'Crypto Payment Gateway',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.ZI_CHARGE]: {
    logo: ziChargeImg,
    title: 'Zi Charge',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.FIAT_PAY]: {
    logo: avatarNoImg,
    title: 'Fiat Pay',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.WITCHER_V1]: {
    logo: avatarNoImg,
    title: 'Witcher Pro',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.SISTEM_NAKIT]: {
    logo: avatarNoImg,
    title: 'Sistem Nakit',
    subtitle: 'Fiat',
  },
  [PaymentProviderName.PARSCOINPAY]: {
    logo: avatarNoImg,
    title: 'ParsCoinPay',
    subtitle: '',
  },
  [PaymentProviderName.PARAM_HAVALE]: {
    logo: avatarNoImg,
    title: 'Param Havale',
    subtitle: '',
  },
  [PaymentProviderName.CASPIAN_PAY]: {
    logo: avatarNoImg,
    title: 'Caspian Pay',
    subtitle: '',
  },
  [PaymentProviderName.UTOPIA]: {
    logo: avatarNoImg,
    title: 'Utopia',
    subtitle: '',
  },
  [PaymentProviderName.MALDO_PAY]: {
    logo: avatarNoImg,
    title: 'Maldo Pay',
    subtitle: '',
  },
  [PaymentProviderName.FX_HAVALE]: {
    logo: avatarNoImg,
    title: 'FX Havale',
    subtitle: '',
  },
  [PaymentProviderName.U_WALLET]: {
    logo: avatarNoImg,
    title: 'uWallet',
    subtitle: '',
  },
  [PaymentProviderName.ALTITUDE_PAY]: {
    logo: avatarNoImg,
    title: 'Altitude Pay',
    subtitle: '',
  },
  [PaymentProviderName.APPLE_PAY_CRYPTO]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.EASY_PAY_HAVALE_EWALLET]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.EASY_PAY_HAVALE_BANK]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.SERIAL_HAVALE]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.VITA_HAVALE]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.SAFE_PLUS_PAY]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.PAYMENT_PARSIR]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.FAST_HAVALE]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.TRUST_PAY]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.HIZLI_ODE]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.CASPIAN_PAY_CRYPTO]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.DENIZ_PAY]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
  [PaymentProviderName.PORK_GATE]: {
    logo: avatarNoImg,
    title: 'Apple Pay',
    subtitle: '',
  },
};

export const registrationMethodOptions = [
  {
    title: 'Email',
    icon: faEnvelope,
    value: PlayerProfileType.EMAIL,
    color: california[300],
  },
  {
    title: 'Telegram',
    icon: faTelegram,
    value: PlayerProfileType.TELEGRAM,
    color: california[300],
  },
  {
    title: 'Google',
    icon: faGoogle,
    value: PlayerProfileType.GOOGLE,
    color: california[300],
  },
  {
    title: 'Web3',
    img: iconMetamask,
    value: PlayerProfileType.METAMASK,
  },
];

export const playerSubInfoOptions = [
  {
    title: 'Username',
    icon: faCircleUser,
    value: PlayerSubInfo.USERNAME,
    color: california[300],
  },
  {
    title: 'Contact Info',
    icon: faIdCard,
    value: PlayerSubInfo.CONTACT_INFO,
    color: california[300],
  },
];

export const gameTagsList = [
  { title: 'Hot', value: GameTag.HOT },
  { title: 'New', value: GameTag.NEW },
  { title: 'Live', value: GameTag.LIVE },
  { title: 'Trending', value: GameTag.TRENDING },
];

export const gameCategoriesList = [
  { title: 'Crash Games', value: GameCategory.CRASH_GAMES },
  { title: 'Slots', value: GameCategory.SLOTS },
  { title: 'Table Games', value: GameCategory.TABLE_GAMES },
  { title: 'Live Casino', value: GameCategory.LIVE_CASINO },
  { title: 'Jackpots', value: GameCategory.JACKPOTS },
  { title: 'Other', value: GameCategory.OTHER },
  { title: 'Scratch Cards', value: GameCategory.SCRATCH_CARDS },
  { title: 'Video Poker', value: GameCategory.VIDEO_POKER },
  { title: 'Roulette', value: GameCategory.ROULETTE },
  { title: 'Fast Game', value: GameCategory.FAST_GAME },
];

export const countryMapping: CountryMapping = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua and Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AQ: 'Antarctica',
  AR: 'Argentina',
  AS: 'American Samoa',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AX: 'Åland Islands',
  AZ: 'Azerbaijan',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'Saint Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei Darussalam',
  BO: 'Bolivia (Plurinational State of)',
  BQ: 'Bonaire, Sint Eustatius and Saba',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CC: 'Cocos (Keeling) Islands',
  CD: 'Congo, Democratic Republic of the',
  CF: 'Central African Republic',
  CG: 'Congo',
  CH: 'Switzerland',
  CI: "Côte d'Ivoire",
  CK: 'Cook Islands',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cabo Verde',
  CW: 'Curaçao',
  CX: 'Christmas Island',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  EH: 'Western Sahara',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands (Malvinas)',
  FM: 'Micronesia (Federated States of)',
  FO: 'Faroe Islands',
  FR: 'France',
  GA: 'Gabon',
  GB: 'UK',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GG: 'Guernsey',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GS: 'South Georgia and the South Sandwich Islands',
  GT: 'Guatemala',
  GU: 'Guam',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HM: 'Heard Island and McDonald Islands',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IM: 'Isle of Man',
  IN: 'India',
  IO: 'British Indian Ocean Territory',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JE: 'Jersey',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KI: 'Kiribati',
  KM: 'Comoros',
  KN: 'Saint Kitts and Nevis',
  KP: "Korea (Democratic People's Republic of)",
  KR: 'Korea, Republic of',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: "Lao People's Democratic Republic",
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova, Republic of',
  ME: 'Montenegro',
  MF: 'Saint Martin (French part)',
  MG: 'Madagascar',
  MH: 'Marshall Islands',
  MK: 'North Macedonia',
  ML: 'Mali',
  MM: 'Myanmar',
  MN: 'Mongolia',
  MO: 'Macao',
  MP: 'Northern Mariana Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PM: 'Saint Pierre and Miquelon',
  PN: 'Pitcairn',
  PR: 'Puerto Rico',
  PS: 'Palestine, State of',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  SI: 'Slovenia',
  SJ: 'Svalbard and Jan Mayen',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  SS: 'South Sudan',
  ST: 'Sao Tome and Principe',
  SV: 'El Salvador',
  SX: 'Sint Maarten (Dutch part)',
  SY: 'Syrian Arab Republic',
  SZ: 'Eswatini',
  TC: 'Turks and Caicos Islands',
  TD: 'Chad',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TK: 'Tokelau',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Turkey',
  TT: 'Trinidad and Tobago',
  TV: 'Tuvalu',
  TW: 'Taiwan, Province of China',
  TZ: 'Tanzania, United Republic of',
  UA: 'Ukraine',
  UG: 'Uganda',
  UM: 'United States Minor Outlying Islands',
  US: 'USA',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VA: 'Holy See',
  VC: 'Saint Vincent and the Grenadines',
  VE: 'Venezuela (Bolivarian Republic of)',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  VN: 'Viet Nam',
  VU: 'Vanuatu',
  WF: 'Wallis and Futuna',
  WS: 'Samoa',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
};

export const languages: Record<string, { label: string }> = {
  // ak: { label: 'Akan' },
  // am: { label: 'Amharic' },
  ar: { label: 'Arabic' },
  // as: { label: 'Assamese' },
  // awd: { label: 'Awadhi' },
  // az: { label: 'Azerbaijani' },
  // bn: { label: 'Bengali' },
  // bho: { label: 'Bhojpuri' },
  // my: { label: 'Burmese' },
  // km: { label: 'Khmer' },
  // cs: { label: 'Czech' },
  en: { label: 'English' },
  tl: { label: 'Tagalog' },
  // eo: { label: 'Esperanto' },
  es: { label: 'Spanish' },
  // et: { label: 'Estonian' },
  fa: { label: 'Persian' },
  // fi: { label: 'Finnish' },
  fr: { label: 'French' },
  // ful: { label: 'Fula' },
  de: { label: 'German' },
  // el: { label: 'Greek' },
  // gu: { label: 'Gujarati' },
  // ha: { label: 'Hausa' },
  // he: { label: 'Hebrew' },
  // hi: { label: 'Hindi' },
  // hmn: { label: 'Hmong' },
  // hu: { label: 'Hungarian' },
  // ig: { label: 'Igbo' },
  // id: { label: 'Indonesian' },
  it: { label: 'Italian' },
  // ja: { label: 'Japanese' },
  // jv: { label: 'Javanese' },
  // kn: { label: 'Kannada' },
  // kk: { label: 'Kazakh' },
  // ks: { label: 'Kashmiri' },
  // km: { label: 'Khmer' },
  // rw: { label: 'Kinyarwanda' },
  // ko: { label: 'Korean' },
  ckb: { label: 'Kurdish-Sorani' },
  // ky: { label: 'Kyrgyz' },
  // lo: { label: 'Lao' },
  // lv: { label: 'Latvian' },
  // lt: { label: 'Lithuanian' },
  // lb: { label: 'Luxembourgish' },
  // mk: { label: 'Macedonian' },
  // ms: { label: 'Malay' },
  // ml: { label: 'Malayalam' },
  // mg: { label: 'Malagasy' },
  // mt: { label: 'Maltese' },
  // gv: { label: 'Manx' },
  // mi: { label: 'Mĝori' },
  // mr: { label: 'Marathi' },
  // mh: { label: 'Marshallese' },
  // mn: { label: 'Mongolian' },
  // ne: { label: 'Nepali' },
  // no: { label: 'Norwegian' },
  // or: { label: 'Odia' },
  // om: { label: 'Oromo' },
  // ps: { label: 'Pashto' },
  // pa: { label: 'Punjabi' },
  pl: { label: 'Polish' },
  pt: { label: 'Portuguese' },
  // ro: { label: 'Romanian' },
  ru: { label: 'Russian' },
  // sm: { label: 'Samoan' },
  // sr: { label: 'Serbian' },
  // sn: { label: 'Shona' },
  // si: { label: 'Sinhala' },
  // sk: { label: 'Slovak' },
  // sl: { label: 'Slovenian' },
  // so: { label: 'Somali' },
  // st: { label: 'Southern Sotho' },
  // su: { label: 'Sundanese' },
  // sw: { label: 'Swahili' },
  // sv: { label: 'Swedish' },
  // tg: { label: 'Tajik' },
  // ta: { label: 'Tamil' },
  // te: { label: 'Telugu' },
  // th: { label: 'Thai' },
  tr: { label: 'Turkish' },
  // tk: { label: 'Turkmen' },
  uk: { label: 'Ukrainian' },
  // ur: { label: 'Urdu' },
  uz: { label: 'Uzbek' },
  // vi: { label: 'Vietnamese' },
  // cy: { label: 'Welsh' },
  // xh: { label: 'Xhosa' },
  // yi: { label: 'Yiddish' },
  // yo: { label: 'Yoruba' },
  // zh: { label: 'Chinese' },
  // zu: { label: 'Zulu' },
  sq: { label: 'Albanian' },
  ja: { label: 'Japanese' },
};

export const timezones: Record<
  string,
  {
    label: string;
    offset: string;
    value: string;
  }
> = {
  HST: {
    label: 'Hawaii-Aleutian Standard Time',
    offset: '-10:00',
    value: 'Pacific/Honolulu',
  },
  AKST: {
    label: 'Alaska Standard Time',
    offset: '-09:00',
    value: 'America/Anchorage',
  },
  PST: {
    label: 'Pacific Standard Time',
    offset: '-08:00',
    value: 'America/Los_Angeles',
  },
  MST: {
    label: 'Mountain Standard Time',
    offset: '-07:00',
    value: 'America/Denver',
  },
  CST: {
    label: 'Central Standard Time',
    offset: '-06:00',
    value: 'America/Chicago',
  },
  EST: {
    label: 'Eastern Standard Time',
    offset: '-05:00',
    value: 'America/New_York',
  },
  AST: {
    label: 'Atlantic Standard Time',
    offset: '-04:00',
    value: 'America/Halifax',
  },
  BRT: {
    label: 'Brasília Time',
    offset: '-03:00',
    value: 'America/Sao_Paulo',
  },
  ART: {
    label: 'Argentina Time',
    offset: '-03:00',
    value: 'America/Argentina/Buenos_Aires',
  },
  UTC: {
    label: 'Coordinated Universal Time',
    offset: '+00:00',
    value: 'Etc/UTC',
  },
  GMT: {
    label: 'Greenwich Mean Time',
    offset: '+00:00',
    value: 'Etc/GMT',
  },
  WAT: {
    label: 'West Africa Time',
    offset: '+01:00',
    value: 'Africa/Lagos',
  },
  CET: {
    label: 'Central European Time',
    offset: '+01:00',
    value: 'Europe/Berlin',
  },
  EET: {
    label: 'Eastern European Time',
    offset: '+02:00',
    value: 'Europe/Helsinki',
  },
  CAT: {
    label: 'Central Africa Time',
    offset: '+02:00',
    value: 'Africa/Maputo',
  },
  SAST: {
    label: 'South Africa Standard Time',
    offset: '+02:00',
    value: 'Africa/Johannesburg',
  },
  MSK: {
    label: 'Moscow Standard Time',
    offset: '+03:00',
    value: 'Europe/Moscow',
  },
  EAT: {
    label: 'East Africa Time',
    offset: '+03:00',
    value: 'Africa/Nairobi',
  },
  IRST: {
    label: 'Iran Standard Time',
    offset: '+03:30',
    value: 'Asia/Tehran',
  },
  IST: {
    label: 'India Standard Time',
    offset: '+05:30',
    value: 'Asia/Kolkata',
  },
  PKT: {
    label: 'Pakistan Standard Time',
    offset: '+05:00',
    value: 'Asia/Karachi',
  },
  BST: {
    label: 'Bangladesh Standard Time',
    offset: '+06:00',
    value: 'Asia/Dhaka',
  },
  CCT: {
    label: 'Cocos Islands Time',
    offset: '+06:30',
    value: 'Indian/Cocos',
  },
  WIB: {
    label: 'Western Indonesian Time',
    offset: '+07:00',
    value: 'Asia/Jakarta',
  },
  AWST: {
    label: 'Australian Western Standard Time',
    offset: '+08:00',
    value: 'Australia/Perth',
  },
  SGT: {
    label: 'Singapore Time',
    offset: '+08:00',
    value: 'Asia/Singapore',
  },
  MYT: {
    label: 'Malaysia Time',
    offset: '+08:00',
    value: 'Asia/Kuala_Lumpur',
  },
  HKT: {
    label: 'Hong Kong Time',
    offset: '+08:00',
    value: 'Asia/Hong_Kong',
  },
  PHT: {
    label: 'Philippine Time',
    offset: '+08:00',
    value: 'Asia/Manila',
  },
  WITA: {
    label: 'Central Indonesia Time',
    offset: '+08:00',
    value: 'Asia/Makassar',
  },
  JST: {
    label: 'Japan Standard Time',
    offset: '+09:00',
    value: 'Asia/Tokyo',
  },
  KST: {
    label: 'Korea Standard Time',
    offset: '+09:00',
    value: 'Asia/Seoul',
  },
  ACST: {
    label: 'Australian Central Standard Time',
    offset: '+09:30',
    value: 'Australia/Adelaide',
  },
  AEST: {
    label: 'Australian Eastern Standard Time',
    offset: '+10:00',
    value: 'Australia/Sydney',
  },
  ACDT: {
    label: 'Australian Central Daylight Time',
    offset: '+10:30',
    value: 'Australia/Adelaide',
  },
  AEDT: {
    label: 'Australian Eastern Daylight Time',
    offset: '+11:00',
    value: 'Australia/Sydney',
  },
  NZST: {
    label: 'New Zealand Standard Time',
    offset: '+12:00',
    value: 'Pacific/Auckland',
  },
  NZDT: {
    label: 'New Zealand Daylight Time',
    offset: '+13:00',
    value: 'Pacific/Auckland',
  },
};

export const emptyColumn = { type: { text: { content: '-' } } };
export const comingSoonColumn = { type: { text: { content: 'Coming Soon' } } };

export const supportedMedia: MediaItemProps[] = [
  {
    custom_key: 'desktop',
    title: 'Desktop',
    image: '',
    file: undefined,
    type: 'page',
    tags: ['page', 'banner', 'desktop'],
  },
  {
    custom_key: 'mobile',
    title: 'Mobile',
    image: '',
    file: undefined,
    type: 'page',
    tags: ['page', 'banner', 'mobile'],
  },
  {
    custom_key: 'desktop_thumbnail',
    title: 'Desktop Thumbnail',
    image: '',
    file: undefined,
    type: 'page',
    tags: ['page', 'thumbnail', 'desktop'],
  },
  {
    custom_key: 'mobile_thumbnail',
    title: 'Mobile Thumbnail',
    image: '',
    file: undefined,
    type: 'page',
    tags: ['page', 'thumbnail', 'mobile'],
  },
  {
    custom_key: 'home_banner_desktop_guest',
    title: 'Home Banner Desktop (Before Login)',
    image: '',
    file: undefined,
    type: 'component',
    tags: ['home-banner', 'before-login', 'desktop', 'home-banner-default'],
  },
  {
    custom_key: 'home_banner_desktop',
    title: 'Home Banner Desktop (After Login)',
    image: '',
    file: undefined,
    type: 'component',
    tags: ['home-banner', 'after-login', 'home-banner-default-login'],
  },
  {
    custom_key: 'home_banner_mobile_guest',
    title: 'Home Banner Desktop (Before Login)',
    image: '',
    file: undefined,
    type: 'component',
    tags: ['home-banner', 'before-login', 'mobile', 'home-banner-default-mobile'],
  },
  {
    custom_key: 'home_banner_mobile',
    title: 'Home Banner Mobile (After Login)',
    image: '',
    file: undefined,
    type: 'component',
    tags: ['home-banner', 'after-login', 'mobile', 'home-banner-default-mobile-login'],
  },
  {
    custom_key: 'home_slider_desktop',
    title: 'Home Slider Desktop (Before Login)',
    image: '',
    file: undefined,
    type: 'component',
    tags: ['home-slider', 'before-login', 'desktop', 'home-slider-default'],
  },
];

export const bannerMedia: BannerProps[] = [
  {
    title: 'Desktop',
    subtitle: '',
    url: '',
    file: undefined,
    category: '',
    extraData: {},
  },
];

export const GameProviderDetails: Record<
  GameProviders,
  {
    title: string;
    subtitle?: string;
    img: StaticImageData;
    originalProvider?: Record<string, { title: string; img: StaticImageData }>;
  }
> = {
  [GameProviders.IMOON]: {
    title: 'iMoon',
    subtitle: '',
    img: imgImoon,
  },
  [GameProviders.TURBO_STARS]: {
    title: 'Sport',
    subtitle: '',
    img: imgTurboStars,
    originalProvider: {
      evolution: { img: imgEvolution, title: 'Evolution' },
      playNGo: { img: imgPlayNGo, title: `Play'n Go` },
      pragmaticPlay: { img: imgPragmaticPlay, title: `Pragmatic Play` },
      pragmaticPlayLive: {
        img: imgPragmaticPlayLive,
        title: `Pragmatic Play Live`,
      },
    },
  },
  [GameProviders.SOFT_GAMINGS]: {
    title: 'Casino',
    subtitle: '',
    img: imgSoftGaming,
  },
  [GameProviders.CREED_ROOMZ]: {
    title: 'Casino',
    subtitle: '',
    img: imgSoftGaming,
  },
  [GameProviders.SOFTSWISS]: {
    title: 'Casino',
    subtitle: '',
    img: imgSoftGaming,
  },
};

export const themesList = [
  { label: 'Dark Blue & Blue (#2962FF)', value: 'dark_blue_blue_2962FF' },
  { label: 'Purple & Green (#64DD17)', value: 'purple_green_64DD17' },
  { label: 'Gray & Red (#C02929)', value: 'gray_red_C02929' },
  {
    label: 'Blue & Gold Gradient (#FACE3C)',
    value: 'blue_gold_gradient_FACE3C',
  },
  { label: 'Gray & Yellow (#FBDB73)', value: 'gray_yellow_FBDB73' },
  { label: 'Gray & Orange (#E39C1E)', value: 'gray_orange_E39C1E' },
  { label: 'Purple & Yellow (#F7C163)', value: 'purple_yellow_F7C163' },
  { label: 'Gray & Gold (#C28101)', value: 'gray_gold_C28101' },
  { label: 'Gray & Orange (#FFA401)', value: 'gray_orange_FFA401' },
  {
    label: 'Dark Brown & Golden Brown (#C2A377)',
    value: 'dark_brown_golden_brown_C2A377',
  },
  {
    label: 'Dark Purple, Gray & Dark Green (#134F29)',
    value: 'dark_purple_gray_dark_green_134F29',
  },
  { label: 'Gray & Deep Gold (#A97F3F)', value: 'gray_deep_gold_A97F3F' },
  {
    label: 'Navy Blue & Deep Azure (#0764A8)',
    value: 'navy_blue_deep_azure_0764A8',
  },
  {
    label: 'Navy Blue & Golden Yellow (#C28101)',
    value: 'navy_blue_golden_yellow_C28101',
  },
  {
    label: 'Light Blue, Gray & Cyan (#2F6E8B)',
    value: 'light_blue_gray_cyan_2F6E8B',
  },
  {
    label: 'Gray & Gold Gradient (#FFE778)',
    value: 'gray_gold_gradient_FFE778',
  },
  {
    label: 'Dark Blue & Vivid Azure (#006EE3)',
    value: 'dark_blue_vivid_azure_006EE3',
  },
  {
    label: 'Midnight Purple & Bright Orange (#FB8B24)',
    value: 'midnight_purple_bright_orange_FB8B24',
  },
  {
    label: 'Gray & Gold Gradient (#F1C52D)',
    value: 'gray_gold_gradient_F1C52D',
  },
  {
    label: 'Vibrant Lime Green & Lime Green (#66A718)',
    value: 'vibrant_lime_green_lime_green_66A718',
  },
  {
    label: 'Gray & Orange Gradient (#FFC700)',
    value: 'gray_orange_gradient_FFC700',
  },
  {
    label: 'Dark Green & Green (#00674F)',
    value: 'dark_green_and_green_00674F',
  },
  {
    label: 'Dark Deep Green And Yellow (#FCCC06)',
    value: 'dark_deep_green_and_yellow_FCCC06',
  },
  {
    label: 'Dark Purple & Orange (#FF5D18)',
    value: 'dark_purple_orange_FF5D18',
  },
  {
    label: 'Gray & Yellow Solid (#F39C12)',
    value: 'gray_yellow_f39c12',
  },
  {
    label: 'Dark Blue & Blue (#3571A5)',
    value: 'dark_blue_blue_3571A5',
  },
  {
    label: 'Brown & Gold (#F8A31D)',
    value: 'brown_gold_F8A31D',
  },
  {
    label: 'Black & Green Neon (#2CFF05)',
    value: 'black_green_neon_2CFF05',
  },
  {
    label: 'Light Blue & Dark Blue (#013372)',
    value: 'light_blue_dark_blue_013372',
  },
  {
    label: 'Dark Gray & Gold (#F8A31D)',
    value: 'dark_gray_gold_F8A31D',
  },
  {
    label: 'Purple & Yellow (#F09035)',
    value: 'purple_yellow_F09035',
  },
  {
    label: 'Black & Orange (#C96120)',
    value: 'black_orange_C96120',
  },
  {
    label: 'Black & Yellow (#FFEB3B)',
    value: 'black_yellow_FFEB3B',
  },
  {
    label: 'Green & Yellow (#FFEB3B)',
    value: 'green_yellow_FFEB3B',
  },
];

export const intervalMapping: Record<ReportTimeInterval, ManipulateType> = {
  [ReportTimeInterval.MINUTE]: 'minute',
  [ReportTimeInterval.HOUR]: 'hour',
  [ReportTimeInterval.DAY]: 'day',
  [ReportTimeInterval.MONTH]: 'month',
  [ReportTimeInterval.YEAR]: 'year',
};
export const availablePageTypes = [{ value: 'text-page', label: 'Text Page' }];

export const typographyMenuItemList = [
  { label: 'H1', value: 'h1' },
  { label: 'H2', value: 'h2' },
  { label: 'H3', value: 'h3' },
  { label: 'H4', value: 'h4' },
  { label: 'H5', value: 'h5' },
  { label: 'H6', value: 'h6' },

  { label: 'Sub H1', value: 'subH1' },
  { label: 'Sub H2', value: 'subH2' },

  { label: 'Large Extra Bold', value: 'largeExtraBold' },
  { label: 'Large Bold', value: 'largeBold' },
  { label: 'Large', value: 'large' },

  { label: 'Medium Extra Bold', value: 'mediumExtraBold' },
  { label: 'Medium Bold', value: 'mediumBold' },
  { label: 'Medium', value: 'medium' },

  { label: 'Small Extra Bold', value: 'smallExtraBold' },
  { label: 'Small Bold', value: 'smallBold' },
  { label: 'Small', value: 'small' },

  { label: 'X Small Extra Bold', value: 'xSmallExtraBold' },
  { label: 'X Small Bold', value: 'xSmallBold' },
  { label: 'X Small', value: 'xSmall' },

  { label: 'Caption Extra Bold', value: 'captionExtraBold' },
  { label: 'Caption Bold', value: 'captionBold' },
  { label: 'Caption', value: 'caption' },
];

export const disciplineMenuItems = [
  { label: 'American Football', value: 'American Football' },
  { label: 'Arena of Valor', value: 'Arena of Valor' },
  { label: 'Aussie Rules', value: 'Aussie Rules' },
  { label: 'Badminton', value: 'Badminton' },
  { label: 'Baseball', value: 'Baseball' },
  { label: 'Basketball', value: 'Basketball' },
  { label: 'Basketball 3х3', value: 'Basketball 3х3' },
  { label: 'Biathlon', value: 'Biathlon' },
  { label: 'Bowls', value: 'Bowls' },
  { label: 'Boxing', value: 'Boxing' },
  { label: 'Call of Duty', value: 'Call of Duty' },
  { label: 'Counter-Strike', value: 'Counter-Strike' },
  { label: 'Cricket', value: 'Cricket' },
  { label: 'Darts', value: 'Darts' },
  { label: 'Dota 2', value: 'Dota 2' },
  { label: 'eBasketball', value: 'eBasketball' },
  { label: 'eCricket', value: 'eCricket' },
  { label: 'eFootball', value: 'eFootball' },
  { label: 'eHockey', value: 'eHockey' },
  { label: 'eMMA', value: 'eMMA' },
  { label: 'Entertainment', value: 'Entertainment' },
  { label: 'eTennis', value: 'eTennis' },
  { label: 'Football', value: 'Football' },
  { label: 'Formula 1', value: 'Formula 1' },
  { label: 'Futsal', value: 'Futsal' },
  { label: 'Golf', value: 'Golf' },
  { label: 'Handball', value: 'Handball' },
  { label: 'Ice Hockey', value: 'Ice Hockey' },
  { label: 'Kabaddi', value: 'Kabaddi' },
  { label: 'King of Glory', value: 'King of Glory' },
  { label: 'League of Legends', value: 'League of Legends' },
  { label: 'MMA', value: 'MMA' },
  { label: 'Mobile Legends', value: 'Mobile Legends' },
  { label: 'Overwatch', value: 'Overwatch' },
  { label: 'Politics', value: 'Politics' },
  { label: 'PUBG', value: 'PUBG' },
  { label: 'Rainbow 6', value: 'Rainbow 6' },
  { label: 'Rocket League', value: 'Rocket League' },
  { label: 'Rugby', value: 'Rugby' },
  { label: 'Snooker', value: 'Snooker' },
  { label: 'StarCraft 2', value: 'StarCraft 2' },
  { label: 'Table Tennis', value: 'Table Tennis' },
  { label: 'Tennis', value: 'Tennis' },
  { label: 'Valorant', value: 'Valorant' },
  { label: 'Volleyball', value: 'Volleyball' },
  { label: 'Warcraft III', value: 'Warcraft III' },
];

export const providerMenuItems = [
  { label: 'iMoon', value: 'iMoon' },
  { label: 'Alien', value: 'Alien' },
  { label: 'Pragmatic Play', value: 'Pragmatic Play' },
  { label: "Play'n Go", value: "Play'n Go" },
  { label: 'Pragmatic Play Live', value: 'Pragmatic Play Live' },
  { label: 'Evolution', value: 'Evolution' },
  { label: 'Evo play Games', value: 'Evo play Games' },
  { label: 'Ezugi', value: 'Ezugi' },
  { label: 'BoomingGames', value: 'BoomingGames' },
  { label: 'EGTDigital', value: 'EGTDigital' },
  { label: 'Fugaso', value: 'Fugaso' },
  { label: 'NetEntOSS', value: 'NetEntOSS' },
  { label: 'PGSoft', value: 'PGSoft' },
  { label: 'PGSoft', value: 'PGSoft' },
  { label: 'PlaynGo', value: 'PlaynGo' },
  { label: 'Push Gaming', value: 'Push Gaming' },
  { label: 'SmartSoft', value: 'SmartSoft' },
  { label: 'TomHornGaming', value: 'TomHornGaming' },
  { label: 'Spribe', value: 'Spribe' },
  { label: 'Wazdan', value: 'Wazdan' },
  { label: 'Yggdrasil', value: 'Yggdrasil' },
];

export const buttonActions = [
  { label: 'Login', value: '?type=modal&event=LOGIN' },
  { label: 'Register', value: '?type=modal&event=REGISTER' },
  { label: 'Deposit Methods', value: '?type=modal&event=WALLETDPOSIT' },
  {
    label: 'Withdraw Methods',
    value: '?type=modal&event=WALLETWITHDRAW',
  },
  { label: 'Main Menu', value: '?type=modal&event=MENU' },
  {
    label: 'Transactions History',
    value: '?type=modal&event=TRANSACTION',
  },
  { label: 'Bets History', value: '?type=modal&event=BETS' },
  { label: 'Profile', value: '?type=modal&event=PROFILE' },
  { label: 'Referral', value: '?type=modal&event=REFERRAL' },
  { label: 'Support', value: '?type=modal&event=SUPPORT' },
  { label: 'Notification', value: '?type=modal&event=NOTIFICATION' },
  // { label: 'Reset Timer', value: '?type=modal&event=RESETTIMER' },
  { label: 'Reset Password', value: '?type=modal&event=NEWPASSWORD' },
];

export const buttonScrollTargets = [
  { label: 'Home', value: '?type=scroll&event=home' },
  { label: 'Casino Section', value: '?type=scroll&event=section-casino' },
  {
    label: 'Tournament Section',
    value: '?type=scroll&event=section-tournament',
  },
];
